import { ComponentParams, ComponentRendering } from '@sitecore-content-sdk/nextjs';
import { UserProfile } from '@generated/UserProfile/EmailUnsubscribe.model';
import EmailUnsubscribe from './EmailUnsubscribe';
import PlainTextWrapper from 'components/helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import RichTextWrapper from 'components/helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import useIsEditing from 'lib/hooks/sitecore/useIsEditing';

type EmailUnsubscribeComponentProps = {
  rendering: ComponentRendering & { params: ComponentParams };
  params: ComponentParams;
  fields: UserProfile.EmailUnsubscribe.EmailUnsubscribe['fields'];
};

const EmailUnsubscribeDefaultComponent = (props: EmailUnsubscribeComponentProps): JSX.Element => {
  // const { sitecoreContext } = useSitecoreContext();
  const isEditing = useIsEditing();

  // Get subscription ID from Sitecore site settings
  // const subscriptionId = getSubscriptionId(sitecoreContext);
  // Temporary: Hardcoded Betty Crocker subscription ID for testing
  //   const subscriptionId = '1e34a555-89d1-45f0-8f07-b3ae6b01c03c';

  if (!props.fields && !isEditing) {
    return <></>;
  }

  return (
    <EmailUnsubscribe
      formTitle={
        <PlainTextWrapper
          field={props.fields?.title}
          fallback="Don't want to hear from us anymore?"
        />
      }
      formSubheading={
        <RichTextWrapper
          field={props.fields?.description}
          fallback="To stop receiving emails, enter your email below and click unsubscribe."
        />
      }
      emailLabel={<PlainTextWrapper field={props.fields?.emailLabel} fallback="Email Address" />}
      emailPlaceholder={props.fields?.emailPlaceholder?.value || 'example@email.com'}
      ctaButtonText={
        <PlainTextWrapper field={props.fields?.unsubscribeLink} fallback="Unsubscribe" />
      }
      requiredText={<PlainTextWrapper field={props.fields?.instruction} fallback="* Required" />}
    />
  );
};

export default EmailUnsubscribeDefaultComponent;
